import { render, staticRenderFns } from "./match-manage.vue?vue&type=template&id=eeeb9cde&scoped=true"
import script from "./match-manage.vue?vue&type=script&lang=js"
export * from "./match-manage.vue?vue&type=script&lang=js"
import style0 from "./match-manage.vue?vue&type=style&index=0&id=eeeb9cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeeb9cde",
  null
  
)

export default component.exports